// Jimo injects its UI (styled-components based iframes) into <body>.
// Its CSS lives in CSSOM rules that Turbo's HTML snapshot cannot serialize, so
// on a restore visit (browser back/forward) the widgets reappear unstyled:
// default 300x150 inline iframes with inset borders, visible as gray vertical
// bars below the navbar. The restored nodes are inert clones with no listeners
// or styles, so drop them from the snapshot entirely.
const THIRD_PARTY_ROOT_SELECTORS = ["#jimo_container"]

document.addEventListener("turbo:before-cache", () => {
  THIRD_PARTY_ROOT_SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((node) => node.remove())
  })
})
